export default "__VITE_ASSET__CEN68RoK__"